import * as React from "react";
import { Player } from "@lottiefiles/react-lottie-player";

function ComingSoon() {
  return (
    <div className="flex flex-col justify-center items-center pt-20">
      <Player
        loop
        autoplay
        src="https://lottie.host/e41215b5-1d35-41e5-ad35-60c01d70db17/gufVfnLZZZ.json"
        style={{
          aspectRatio: "16:9",
          width: "100%",
          height: "100%",
        }}
      />
    </div>
  );
}

export default ComingSoon;
